<template>
    <div class="animated">
        <div v-if="registered" class="has-text-centered">
            <span class="icon is-large has-text-success">
                <i class="mdi mdi-48px mdi-email-check-outline"></i>
            </span>
            <h3 class="title is-4 mt-4 has-text-white">{{ $t('Registration successful!') }}</h3>
            <p class="has-text-primary-light mb-5">
                {{
                    $t(
                        "We've sent a verification link to your email address. Please check your inbox and click the link to activate your account."
                    )
                }}
            </p>
            <router-link :to="{ name: 'login' }" class="button is-primary is-medium is-fullwidth">
                {{ $t('Go to login') }}
            </router-link>
        </div>

        <form v-else @submit.prevent="onSubmit" role="form">
            <b-field
                :label="$t('Email')"
                :type="form.errors.has('email') ? 'is-danger' : null"
                :message="form.errors.get('email')"
            >
                <b-input
                    v-model="form.email"
                    type="email"
                    :placeholder="$t('Email')"
                    icon="email-outline"
                    name="email"
                    required
                    autofocus
                    size="is-medium"
                />
            </b-field>

            <b-field
                :label="$t('Password')"
                :type="form.errors.has('password') ? 'is-danger' : null"
                :message="form.errors.get('password')"
            >
                <b-input
                    v-model="form.password"
                    type="password"
                    :placeholder="$t('Password')"
                    icon="lock"
                    password-reveal
                    name="password"
                    required
                    size="is-medium"
                />
            </b-field>

            <b-field
                :label="$t('Password confirmation')"
                :type="form.errors.has('password_confirmation') ? 'is-danger' : null"
                :message="form.errors.get('password_confirmation')"
            >
                <b-input
                    v-model="form.password_confirmation"
                    type="password"
                    :placeholder="$t('Password confirmation')"
                    icon="lock"
                    password-reveal
                    name="password_confirmation"
                    required
                    size="is-medium"
                />
            </b-field>

            <div class="field">
                <p class="control">
                    <button type="submit" class="button is-primary is-medium is-fullwidth">{{ $t('Register') }}</button>
                </p>
            </div>

            <p class="has-text-centered">
                <router-link :to="{ name: 'login' }">
                    {{ $t('Back to login') }}
                </router-link>
            </p>
        </form>
    </div>
</template>

<script>
let fields = {};

export default {
    data() {
        // Init fields
        fields = {
            email: '',
            password: '',
            password_confirmation: ''
        };

        return {
            form: new Form(fields),
            registered: false
        };
    },

    mounted() {
        document.title = i18n.t('Register') + ` | ${AppTitle}`;
    },

    methods: {
        onSubmit() {
            this.form
                .post('/register')
                .then(response => {
                    this.registered = true;
                })
                .catch(error => {});
        }
    }
};
</script>
